/**
 * converts characters to html tag
 * &amp;  - &
 * &gt;   - >
 * &lt;   - <
 * &quot;, &#034; - "
 * 
 * @param {string} text - the input String to be decoded
 * @returns {string} a decoded string free from HTML tags
 */
export function htmlDecode(text) {
    if (text) {
        text = String(text).replace(/&amp;/g, "&").replace(/&gt;/g, ">").replace(/&lt;/g, "<").replace(/&quot;/g, '"').replace(/&#034;/g, '"').replace(/&#39;/g, "'");
    }
    return text;
}
